@if (authorizedRoute) {
  <div class="single-page-main-container">
    <div class="body-container">
      <div class="body-column">
        <router-outlet />
      </div>
    </div>
  </div>
} @else {
  <router-outlet />
}
<app-tracker />
<p-toast
  [breakpoints]="{ '920px': { width: '100%', right: '0', left: '0' } }"
/>
